<!-- 核查记录详情 -->
<template>
    <div v-loading="loading">
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%; margin-bottom: 10px">
                <el-table-column prop="GoodsName" show-overflow-tooltip min-width="200" label="商品名称"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" prop="APCode" label="编码">
                    <template slot-scope="scope">
                        {{ scope.row.APCode }}
                        <el-tag v-if="scope.row.State == 1" class="tag" type="warning">已删除</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="AutoSerise" show-overflow-tooltip min-width="200" label="适用车型"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="OriginalCount" label="库存数"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="CheckCount" label="核查数"></el-table-column>
                <el-table-column show-overflow-tooltip width="120" prop="LableCount" label="关联标签数"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['CheckId'],
    components: {},
    data() {
        return {
            loading: false,
            tableData: []
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpCheckOrder/GetCheckRecordDetail?rId=' + that.CheckId,
                    hideLoading: true
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                })
                .catch(() => {
                    that.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.el-tag {
    height: 24px;
    line-height: 22px;
    margin-left: 8px;
}
</style>
